module.exports = __webpack_public_path__ + "img/spicy_level_three.5264151b.svg";